import api from "@modules/api/api";
import { keepPreviousData, useQuery } from "@tanstack/react-query";

import {
  VehicleFinancePricingRequest,
  VehicleFinancePricingResponse,
} from "../types/VehicleFinancePricingBreakdown";
import consumerFinancingQueryKeys from "../consumerFinancingQueryKeys";

const getPricingBreakdown = async (
  query: VehicleFinancePricingRequest
): Promise<VehicleFinancePricingResponse> => {
  const params = new URLSearchParams({
    sellingPrice: query.sellingPrice.toString(),
    paymentFrequencyId: query.paymentFrequencyId.toString(),
    termInMonths: query.termInMonths.toString(),
    vehicleYear: query.vehicleYear.toString(),
  });

  if (query.cashDownAmount != null) {
    params.append("cashDownAmount", query.cashDownAmount.toString());
  }

  if (query.buyerProvince) {
    params.append("buyerProvince", query.buyerProvince);
  }

  if (query.rate) {
    params.append("rate", query.rate.toString());
  }

  return api.get<VehicleFinancePricingResponse>(
    `api/purchases/c2c-financing/finance-pricing-breakdown?${params.toString()}`
  );
};

export default function useVehicleFinancePricingBreakdown(
  query: VehicleFinancePricingRequest,
  enabled = true
) {
  const { data, isError, isLoading } = useQuery({
    queryKey:
      consumerFinancingQueryKeys.consumerFinancingVehiclePricingBreakdown(
        query
      ),
    queryFn: () => getPricingBreakdown(query),
    enabled: enabled && query.sellingPrice > 0,
    placeholderData: keepPreviousData,
    refetchOnMount: false,
    refetchOnReconnect: false,
    refetchOnWindowFocus: false,
  });

  return {
    pricingBreakdown: data ?? null,
    isLoading,
    isError,
  };
}
